export default "__VITE_ASSET__C$mI9Sl___"